import { useAssetInventoryCompleteness } from "./useAssetInventoryCompleteness";

export function useAssetInventoryHasWarning(clientId: string | undefined): boolean {
  const { data } = useAssetInventoryCompleteness(clientId);
  return data?.sections.some((section) => section.hasWarning) ?? false;
}
